import MuiTextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

import { useTheme } from '../../styles/theme';

const customProps: string[] = ['minWidth', 'maxWidth', 'editing', 'error'];

interface Props {
  error?: boolean;
  editing?: boolean;
  minWidth?: string;
  maxWidth?: string;
}

export const TextStandard = styled(MuiTextField, {
  name: 'telTextField',
  slot: 'Root',
  shouldForwardProp: (prop) => !customProps.includes(prop.toString()),
})<Props>(({ error, editing, minWidth, maxWidth }) => {
  const theme = useTheme();

  return {
    '&.MuiFormControl-root': {
      flexDirection: 'row',
      WebkitFlexDirection: 'row',
    },
    '& .MuiInput-root': {
      fontSize: '1.68ch',
      padding: '2px 0px',
      fontWeight: '500',
      fontFamily: 'Space Grotesk',
      minWidth: minWidth ? minWidth : 'initial',
      maxWidth: maxWidth ? maxWidth : 'initial',
    },
    '& .MuiInput-input': {
      padding: '4px 0 2px',
    },
    '& .MuiInput-root:before': {
      borderColor: error ? theme.telnyx.red : '#212730',
      display: editing ? 'inline' : 'none',
    },
    '& .MuiInput-root:after': {
      borderColor: theme.primary,
    },
    '& .MuiInput-root.Mui-error:after': {
      borderColor: `${theme.telnyx.red} !important`,
    },
    input: {
      color: theme.text.standard,
    },
  };
});
